import ComparableChart from 'components/ComparableChart/ComparableChart'
import { DEFAULT_COLOR, DEFAULT_OPACITY } from 'components/ComparableChart/constants'
import moment from 'locale/momentLocale'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatValidNumber, getMomentDate, hexToRGBA, momentValidDateFormat } from 'utils'

import Box from '@mui/material/Box'

const formatDate = date => (date ? getMomentDate(date).format('L') : '-')
const compareDates = (a, b) => (moment(a.date).isBefore(b.date) ? -1 : 1)

function ReplenishmentTab({ dateCurrent, replenishmentOnHandShoesCurrent, replenishmentTargetShoesCurrent, storeReplenishment }) {
  const { t: translate } = useTranslation()
  const formattedCurrentDate = moment().format(momentValidDateFormat)
  const data = storeReplenishment.sort(compareDates).map(item => {
    const itemDate = moment(item.date).format(translate('date.dayMonthFormat'))
    const formattedDate = `${itemDate[0].toUpperCase()}${itemDate.slice(1)}`

    return {
      color: moment(formattedCurrentDate).isSame(item.date, 'day') ? '#75aedb' : DEFAULT_COLOR,
      compared: Math.round(item.replenishmentOnHandOthersCurrent * 100),
      current: Math.round(item.replenishmentOnHandShoesCurrent * 100),
      tooltipHeader: formattedDate,
      xAxisLabel: formattedDate.split(' '),
    }
  })

  return (
    <div className="store-replenishment-details">
      <div className="store-replenishment-details-date">{formatDate(dateCurrent)}</div>

      <Box className="store-replenishment-details_group" display="flex">
        <Box display="flex">
          <div className="fm fm-replenishment" />

          <div className="value">{Math.round(replenishmentOnHandShoesCurrent || 0 * 100)}%</div>
        </Box>

        <Box display="flex">
          <div className="fm fm-future-replenishment" />

          <div className="value">{Math.round(replenishmentTargetShoesCurrent || 0 * 100)}%</div>
        </Box>
      </Box>

      <div className="store-replenishment-details-chart-title">
        {translate('revenue.details.replenishment.replenishmentLever7Days')}:
      </div>

      <Box className="store-replenishment-details-chart-legend" display="flex">
        <div className="store-replenishment-details-chart-legend-color" style={{ background: DEFAULT_COLOR }} />
        {translate('revenue.details.replenishment.shoes')}

        <div
          className="store-replenishment-details-chart-legend-color"
          style={{ background: hexToRGBA(DEFAULT_COLOR, DEFAULT_OPACITY) }}
        />
        {translate('revenue.details.replenishment.other')}
      </Box>

      <ComparableChart
        barLabelFormatter={value => (value ? `${value}%` : '')}
        data={data}
        height="130px"
        tooltipLabelFormatter={(value, dataKey) =>
          `${translate(
            dataKey === 'current' ? 'revenue.details.replenishment.shoes' : 'revenue.details.replenishment.other',
          )}: ${formatValidNumber(value, '%')}`
        }
        yAxisLabelFormatter={value => `${value}%`}
      />
    </div>
  )
}

ReplenishmentTab.propTypes = {
  dateCurrent: PropTypes.string,
  replenishmentOnHandShoesCurrent: PropTypes.any,
  replenishmentTargetShoesCurrent: PropTypes.any,
  storeReplenishment: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      replenishmentOnHandOtherCurrent: PropTypes.number,
      replenishmentOnHandShoesCurrent: PropTypes.number,
    }),
  ).isRequired,
}

export default ReplenishmentTab
